import { render, staticRenderFns } from "./JackpotForm.vue?vue&type=template&id=2428d3c1&scoped=true&"
import script from "./JackpotForm.vue?vue&type=script&lang=js&"
export * from "./JackpotForm.vue?vue&type=script&lang=js&"
import style0 from "./JackpotForm.vue?vue&type=style&index=0&id=2428d3c1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2428d3c1",
  null
  
)

export default component.exports